import { DropdownOption } from './types';

// ─── CloudFront master data sources ──────────────────────────────────────────

export const STUDENT_JSON_BASE =
  'https://d1wpyxz35bzzz4.cloudfront.net/tnsed_attd_';
export const DISTRICT_MASTER_URL =
  'https://d1wpyxz35bzzz4.cloudfront.net/osc_detail_master.json';
export const COLLEGE_LIST_URL =
  'https://d1wpyxz35bzzz4.cloudfront.net/umis_college_list_new_stage.json';

// ─── "No visit" reason options ───────────────────────────────────────────────

export const REASON_LIST: DropdownOption[] = [
  { label: 'Health issue', value: 1 },
  { label: 'Not interested', value: 2 },
  { label: 'Parents not allowed', value: 3 },
  { label: 'Students with special needs', value: 4 },
  { label: 'Migration', value: 5 },
  { label: 'Passed away', value: 6 },
  { label: 'Long absent/Drop out', value: 7 },
  { label: 'Student has left the school (TC issued)', value: 9 },
  { label: 'Student is absent on the day of the visit', value: 10 },
  { label: 'Others', value: 12 },
];

export const REMOVE_REASON_LIST: DropdownOption[] = [
  { label: 'Student is absent on the day of the visit', value: 1 },
  { label: 'Parent denied permission', value: 2 },
  { label: 'Student has left the school (TC issued)', value: 3 },
  { label: 'Health issues', value: 4 },
  { label: 'Others', value: 7 },
];

function toYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// Minimum allowed visit date: one year ago (yyyy-MM-dd).
export function getMinVisitDate(): string {
  const now = new Date();
  return toYmd(new Date(now.getFullYear() - 1, now.getMonth(), now.getDate()));
}

// Maximum allowed visit date: today (no future dates).
export function getMaxVisitDate(): string {
  return toYmd(new Date());
}
